"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GetData;
require("core-js/modules/es.promise.js");
var _react = _interopRequireDefault(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _EncDec = require("./src/sec/EncDec");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Basic routes and urls
/**
 * Store Data
 * @param {String} store 
 *  session, local or cookies
 * @param {Array} data 
 * ex. [{key: 'test'}, {key: 'username'}]
 */
async function GetData(store) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let customStorage;
  let result = [];
  switch (store) {
    /**
     * Local Storage
     */
    case 'local':
      customStorage = localStorage.getItem('data');
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        if (data[0] === 'all') {
          return result.filter(x => x);
        }
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            result[indexKey] = {
              key: element.key,
              value: 'not found'
            };
          }
        }
      }
      break;
    /**
    * Session Storage
    */
    case 'session':
      customStorage = sessionStorage.getItem('data');
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        if (data[0] === 'all') {
          return result.filter(x => x);
        }
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            result[indexKey] = {
              key: element.key,
              value: 'not found'
            };
          }
        }
      }
      break;
    /**
     * Cookies Storage
     */
    case 'cookies':
      customStorage = _jsCookie.default.get('data');
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        if (data[0] === 'all') {
          return result.filter(x => x);
        }
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            result[indexKey] = {
              key: element.key,
              value: 'not found'
            };
          }
        }
      }
      break;
    default:
      result = [{
        key: 'empty'
      }];
      break;
  }
  if (result.length > 0) {
    return await result.filter(x => x);
  } else {
    return [];
  }
}